// store/selectors/userSelectors.ts
import type { RootState } from "../index.ts";

export const selectUser = (state: RootState) => state.user.user;
export const selectUserId = (state: RootState) => state.user.user?.id;
export const selectAuthEnabled = (state: RootState) => state.user.authEnabled;
export const selectGuestAccessEnabled = (state: RootState) => state.user.guestAccessEnabled;
export const selectAppFeedbackEnabled = (state: RootState) => state.user.appFeedbackEnabled;
export const selectChatFeedbackEnabled = (state: RootState) => state.user.chatFeedbackEnabled;
export const selectChatHistoryEnabled = (state: RootState) => state.user.chatHistoryEnabled;
export const selectStreamingEnabled = (state: RootState) => state.user.streamingEnabled;
export const selectDomainRouting = (state: RootState) => state.user.domainRouting;
export const selectDomainConfig = (state: RootState) => state.user.domainConfig;
export const selectIsGuest = (state: RootState) => state.user.isGuest;
export const selectUserRoles = (state: RootState) => state.user.roles;
export const selectUserLoading = (state: RootState) => state.user.loading;
export const selectUserError = (state: RootState) => state.user.error;

// Computed selectors
export const selectIsAuthenticated = (state: RootState) =>
  state.user.user?.authType === "authenticated";

// Display name selector - uses displayName field or shows "Guest" for guest users
export const selectUserDisplayName = (state: RootState) => {
  const user = state.user.user;
  const isGuest = state.user.isGuest;

  // If guest, always show "Guest"
  if (isGuest) return "Guest";

  // If no user, return null
  if (!user) return null;

  // Return display name or fallback to "User"
  return user.displayName || "User";
};
